import React from 'react';

interface ResidentFurtherInfoProps {
  residentFullName: string;
  residentFurtherInformation: string;
  setResidentFurtherInformation: (value: string) => void;
}

const ResidentFurtherInfo: React.FC<ResidentFurtherInfoProps> = ({
  residentFullName,
  residentFurtherInformation,
  setResidentFurtherInformation,
}) => {
  return (
    <div className="govuk-form-group mt-10 govuk-bp:mt-14">
      <h1 className="govuk-label-wrapper">
        <label
          className="govuk-label govuk-label--l"
          htmlFor="further-information"
        >
          Further information about {residentFullName}
        </label>
      </h1>
      <div id="further-information-hint" className="govuk-hint">
        Please add any further non-medicalised details below. Please do not add
        information contained within external, legally binding documents
        relating to the person&apos;s wishes, decisions and care preferences.
      </div>
      <div id="further-information-hint" className="govuk-hint">
        If the resident has any specific, non medicalised requirements please
        enter them below. You can also add further information about where
        specific documents are located.
      </div>

      <div className="govuk-warning-text">
        <span className="govuk-warning-text__icon" aria-hidden="true">
          !
        </span>
        <strong className="govuk-warning-text__text">
          <span className="govuk-visually-hidden">Warning</span>
          Do not add information contained within external, legally binding
          documents relating to the person&apos;s wishes, decisions and care
          preferences.
        </strong>
      </div>

      <textarea
        className="govuk-textarea"
        id="further-information"
        name="FurtherInformation"
        rows={5}
        aria-describedby="more-detail-hint"
        placeholder="Enter additional details here..."
        value={residentFurtherInformation}
        onChange={e => setResidentFurtherInformation(e.target.value)}
      />
    </div>
  );
};

export default ResidentFurtherInfo;
